import React from 'react';
import { string, arrayOf, number, func } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { ReviewRating } from '../../components';

import css from './ProfileTabs.module.css';

// Calculate average rating from reviews
const calculateAverageRating = reviews => {
  if (!reviews || reviews.length === 0) return 0;
  const totalRating = reviews.reduce((sum, review) => sum + (review.attributes?.rating || 0), 0);
  return totalRating / reviews.length;
};

const ProfileTabs = props => {
  const { activeTab, onTabChange, reviews, listingsCount, className, rootClassName } = props;

  const classes = classNames(rootClassName || css.root, className);
  const averageRating = calculateAverageRating(reviews);

  return (
    <div className={classes} role="tablist">
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === 'listings'}
        className={classNames(css.tab, { [css.tabActive]: activeTab === 'listings' })}
        onClick={() => onTabChange('listings')}
      >
        <FormattedMessage id="ProfileTabs.listings" values={{ count: listingsCount }} />
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === 'feedback'}
        className={classNames(css.tab, { [css.tabActive]: activeTab === 'feedback' })}
        onClick={() => onTabChange('feedback')}
      >
        <span className={css.feedbackTabContent}>
          <FormattedMessage id="ProfileTabs.feedback" values={{ count: reviews.length }} />
          {reviews.length > 0 && (
            <ReviewRating
              className={css.stars}
              reviewStarClassName={css.star}
              rating={Math.min(5, Math.max(1, Math.round(averageRating)))}
            />
          )}
        </span>
      </button>
    </div>
  );
};

ProfileTabs.defaultProps = {
  className: null,
  rootClassName: null,
  reviews: [],
  listingsCount: 0,
};

ProfileTabs.propTypes = {
  className: string,
  rootClassName: string,
  activeTab: string.isRequired,
  onTabChange: func.isRequired,
  reviews: arrayOf(propTypes.review),
  listingsCount: number,
};

export default ProfileTabs;
